import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConversationService } from 'src/app/services/conversation.service';
import { COUNTRY_LIST, SECTOR_LIST } from '../../helpers/data';

@Component({
    selector: 'app-create-conversation',
    templateUrl: './create-conversation.component.html',
    styleUrl: './create-conversation.component.scss',
    standalone: false
})
export class CreateConversationComponent {
	@Output() conversationChanged: EventEmitter<any> = new EventEmitter();

	@ViewChild('createConversationModal') createConversationModal!: TemplateRef<any>;
	@ViewChild('successModal') successModal!: TemplateRef<any>;

	createForm!: UntypedFormGroup;
	submitted = false;
	spinner = false;
	success = false;
	message = '';

	projectID!: number;
	minExpiryDate: Date = new Date();
	existConversationID!: number;

	createConversationModalRef: any;
	successModalRef: any;
	countriesList = COUNTRY_LIST;
	sectorList = SECTOR_LIST;

	constructor(public conversationService: ConversationService, private router: Router, private modalService: NgbModal, private formBuilder: UntypedFormBuilder) { }

	get f() { return this.createForm.controls; }

	openModal(projectID: number) {
		this.submitted = false;
		this.spinner = false;
		this.success = false;

		this.projectID = projectID;

		this.createForm = this.formBuilder.group({
			name: ['', [Validators.required]],
			first_name: ['', [Validators.required]],
			last_name: ['', [Validators.required]],
			gov_id: ['', [Validators.required]],
			email: ['', [Validators.required, Validators.email]],
			country: [null],
			delete_video: [false]
		});

		this.minExpiryDate.setDate(this.minExpiryDate.getDate());

		this.createConversationModalRef = this.modalService.open(this.createConversationModal, { size: 'l', backdrop: 'static', keyboard : false });
	}

	onSubmit() {
		this.submitted = true;
		this.spinner = true;

		if (this.createForm.invalid) {
			this.spinner = false;
			return;
		}

		const data = {
			conversation: {
				name: this.createForm.value.name,
				extra_content: {
					delete_video:  this.createForm.value.delete_video
				}
			},
			person: {
				first_name: this.createForm.value.first_name,
				last_name: this.createForm.value.last_name,
				gov_id: this.createForm.value.gov_id,
				email: this.createForm.value.email,
				country: this.createForm.value.country
			}
		}

		this.conversationService.createConversation(this.projectID, data).subscribe({
			next: (res) => {
				if (res.conversation) {
					this.existConversationID = res.conversation.id;
					this.submitted = false;
					this.spinner = false;
					this.success = false;
					this.message = res.message;

					this.createConversationModalRef.close();
					this.successModalRef = this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
				} else {
					this.submitted = false;
					this.spinner = false;
					this.success = true;
					this.message = res.message;

					this.createConversationModalRef.close();
					this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
				}
			},
			error: (err) =>{
				this.submitted = false;
				this.spinner = false;
				this.success = false;
				this.message = err;
				
				this.createConversationModalRef.close();
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			}
		});
	}

	closeModal() {
		if (this.router.url.includes('conversations')) {
			if (this.success) {
				this.conversationChanged.emit();
			}
		}

		this.createForm.reset();
		this.modalService.dismissAll();
	}
}
